<template>
    <div class="h-100">
        <iframe :src="url" width="100%" height="100%"></iframe>
    </div>
</template>
<script>
export default {
    data(){
        return{
            url: ""
        }
    }
    ,
    mounted(){
        this.url = document.baseAPIurl + "api/swagger";
    }
}
</script>
<style scoped>
iframe{
    border:0;
}
</style>